"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _ = require("../..");

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./Stepper.css");

var _styles = {
  "container": "Stepper__container___UlHbG",
  "step": "Stepper__step___3M_LT",
  "indicator": "Stepper__indicator___1M3Ht",
  "step-label": "Stepper__step-label___2hSaJ",
  "description": "Stepper__description___1gErX",
  "active": "Stepper__active___2Ti-Y",
  "in_progress": "Stepper__in_progress___91NTI",
  "failed": "Stepper__failed___1u2i7",
  "past": "Stepper__past___2I88a",
  "horizontal": "Stepper__horizontal___brD1h",
  "vertical": "Stepper__vertical___Hc8LV",
  "full-width": "Stepper__full-width___lXg7z",
  "vertical-step": "Stepper__vertical-step___1MBJA",
  "continue-button": "Stepper__continue-button___pM96j",
  "no-vertical-padding": "Stepper__no-vertical-padding___3Ig7-",
  "step-button": "Stepper__step-button___1az6A"
};

const styles = _bind.default.bind(_styles);

const Stepper = (0, _mobxReact.observer)(({
  className,
  steps,
  currentStep,
  orientation = 'horizontal',
  dataTestId,
  hideInactiveDescriptions,
  failedSteps = [],
  inProgressSteps = [],
  setStep,
  fullWidth,
  showPastDescriptions,
  animateDescription = false,
  noVerticalContainerPadding
}) => {
  const composed_classname = (0, _bind.default)(styles('container', orientation, {
    'full-width': fullWidth,
    'no-vertical-padding': noVerticalContainerPadding
  }), className);

  const isVerticalStep = step => {
    return typeof step === 'object' && 'step' in step;
  };

  const renderStep = (step, i) => {
    var _a, _b, _c, _d;

    const active = currentStep - 1 === i;
    const past = i + 1 < currentStep;
    const last = steps.length >= steps.indexOf(step) + 1;
    const failed = failedSteps.includes(i + 1);
    const inProgress = isVerticalStep(step) && step.stillInProgress !== undefined ? step.stillInProgress : inProgressSteps.includes(i + 1);
    const step_classname = (0, _bind.default)(styles('step', {
      active,
      past
    }));
    const showDescription = isVerticalStep(step) && step.description && orientation === 'vertical' && (hideInactiveDescriptions && active || last && past || !hideInactiveDescriptions) || past && showPastDescriptions;

    const getStepperIcon = () => {
      if (failed) {
        return _react.default.createElement("div", {
          className: styles('failed')
        }, _react.default.createElement(_.Icon, {
          name: _.IconEnum.x_mark,
          size: 18,
          color: _.Color.neutral.white
        }));
      }

      if (inProgress) {
        return _react.default.createElement("div", {
          className: styles('in_progress')
        }, _react.default.createElement(_.Icon, {
          name: _.IconEnum.circle_half_stroke,
          size: 24
        }));
      }

      if (past) {
        return _react.default.createElement("div", {
          className: styles('indicator')
        }, _react.default.createElement(_.Icon, {
          name: _.IconEnum.check,
          size: 18,
          color: _.Color.neutral.white
        }));
      }

      return _react.default.createElement("div", {
        className: styles('indicator')
      });
    };

    return _react.default.createElement("div", {
      className: step_classname,
      key: `${step}-${i + 1}`
    }, getStepperIcon(), typeof step === 'string' && _react.default.createElement(_.Text, {
      className: styles('step-label'),
      text: step,
      size: 15,
      variant: 'medium'
    }), typeof step === 'object' && _react.default.createElement("div", {
      className: styles('vertical-step')
    }, _react.default.createElement(_.Text, {
      className: styles('step-label'),
      size: 15,
      variant: 'medium'
    }, _react.default.createElement(_react.default.Fragment, null, step.step, step.dateFlag && orientation === 'vertical' && _react.default.createElement(_.DateFlag, {
      text: step.dateFlag
    }))), showDescription && _react.default.createElement(_.Expandable, {
      expand: true,
      showAsExpanded: !animateDescription,
      restOnExpansion: !animateDescription
    }, _react.default.createElement(_react.default.Fragment, null, typeof step.description === 'string' ? _react.default.createElement(_.Text, {
      className: styles('description'),
      text: step.description,
      size: 15
    }) : step.description, step.stepCta && _react.default.createElement(_react.default.Fragment, null, step.stepCta.onClick ? _react.default.createElement(_.Button, {
      onClick: (_a = step.stepCta) === null || _a === void 0 ? void 0 : _a.onClick,
      label: (_b = step.stepCta) === null || _b === void 0 ? void 0 : _b.text,
      variant: 'tertiary',
      className: (0, _bind.default)(styles('step-button'))
    }) : _react.default.createElement(_.Link, {
      text: (_c = step.stepCta) === null || _c === void 0 ? void 0 : _c.text,
      href: (_d = step.stepCta) === null || _d === void 0 ? void 0 : _d.href,
      external: step.stepCta.external,
      variant: 'medium',
      size: 15
    })), setStep && active && _react.default.createElement(_.Button, {
      className: styles('continue-button'),
      flexAlignSelf: 'flex-start',
      disabled: !active,
      label: 'Continue',
      onClick: () => setStep(currentStep + 1)
    })))));
  };

  return _react.default.createElement("div", {
    className: composed_classname,
    "data-testid": dataTestId
  }, steps.map((step, i) => renderStep(step, i)));
});
var _default = Stepper;
exports.default = _default;